jQuery(document).ready(function(){
	jQuery(document).on('click','.menu_toggle',function(e){
		e.preventDefault();
		if(jQuery(this).hasClass('open')){
			
			jQuery('.main-content-wrapper').removeClass('open');
			jQuery('.menu_toggle').removeClass('open');
			jQuery('body').removeClass('menu_open');
			jQuery('.mobile_menu').removeClass('open');
		}
		else{
			
			jQuery('.mobile_menu').addClass('open');
			jQuery('.main-content-wrapper').addClass('open');
			jQuery('.menu_toggle').addClass('open');
			jQuery('body').addClass('menu_open');
		}
		
	});
	jQuery(document).on('click','.main-content-wrapper.open',function(e){
		e.preventDefault();
		jQuery('.mobile_menu').removeClass('open');
		jQuery('.menu_toggle').removeClass('open');
		jQuery('body').removeClass('menu_open');
		jQuery(this).removeClass('open');
	});
	
	//owlslider
	jQuery('.owl-carousel').owlCarousel({
		loop:true,
		responsiveClass:true,
		center: true,
		responsive:{
				0:{
					items: 2,
					nav:true,
					navText: ["<img src='/wp-content/themes/JointsWP/assets/images/arrow_left.svg' />",
							  "<img src='/wp-content/themes/JointsWP/assets/images/arrow_right.svg' />"]
				},
				600:{
					items:3,
					nav:true,
					navText: ["<img src='/wp-content/themes/JointsWP/assets/images/arrow_left.svg' />",
							  "<img src='/wp-content/themes/JointsWP/assets/images/arrow_right.svg' />"]
				},
				900:{
					items:4,
					nav:true,
					navText: ["<img src='/wp-content/themes/JointsWP/assets/images/arrow_left.svg' />",
							  "<img src='/wp-content/themes/JointsWP/assets/images/arrow_right.svg' />"]
				},
				1000:{
					items:6,
					nav:true,
					navText: ["<img src='/wp-content/themes/JointsWP/assets/images/arrow_left.svg' />",
							  "<img src='/wp-content/themes/JointsWP/assets/images/arrow_right.svg' />"]
				},	
				1920:{
					items:7,
					nav:true,
					navText: ["<img src='/wp-content/themes/JointsWP/assets/images/arrow_left.svg' />",
							  "<img src='/wp-content/themes/JointsWP/assets/images/arrow_right.svg' />"]
				}			}
		});
	
	/* Search form
	
	jQuery('.search-form').focusOut(function(){
		jQuery(this).toggleClass('active');
	});
	*/
	jQuery('.search-form').click(function(){
		jQuery(this).toggleClass('active');
	});
	jQuery('a[href="#chatlink"]').click(function(){
		jQuery('#chat').show();
	});
	jQuery('#chat .close-button').click(function(){
		jQuery('#chat').hide();
	});
});